let API_URL = process.env.REACT_APP_API_URL;

exports.BASE_URL = API_URL;
